/* angular */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

/* material components */
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule, MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { ScrollingModule } from '@angular/cdk/scrolling';

/* additional 3rd party components */
import { TranslateModule } from '@ngx-translate/core';
import { AngularSplitModule } from 'angular-split';
import { ComponentsModule } from '@ldw/components';

/* routing */
import { LivedokwebRouting } from '../livedokweb.routes';

/* directives, pipes, constants */
import { CustomTooltipDefaults } from './models/custom-tooltip-defaults';

import { RoesbergModule } from '@ldw/roesberg';

/* dialogs */
import { ConfirmDialogComponent } from './dialogs/confirm-dialog/confirm-dialog.component';
import { DocumentNotFoundDialogComponent } from './dialogs/document-not-found-dialog/document-not-found-dialog.component';
import { ErrorDialogComponent } from './dialogs/error-dialog/error-dialog.component';

/* components */
import { StructureListItemComponent } from './components/structure-list-item/structure-list-item.component';
import { StructureListViewComponent } from './components/structure-list-view/structure-list-view.component';
import { SplitViewComponent } from './components/split-view/split-view.component';
import { LoadingIndicatorComponent } from './components/loading-indicator/loading-indicator.component';
import { StatusLabelComponent } from './components/status-label/status-label.component';
import { StatusSelectComponent } from './components/status-select/status-select.component';
import { PlanningJobSelectComponent } from './components/planning-job-select/planning-job-select.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { NodeValueListViewComponent } from './components/node-value-list-view/node-value-list-view.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

import { DocumentImagesComponent } from './components/document-images/document-images.component';
import { StructureBreadCrumbComponent } from './components/structure-bread-crumb/structure-bread-crumb.component';
import { TruncatedTextComponent } from './components/truncated-text/truncated-text.component';
import { ScrollIntoViewDirective } from './components/scroll-into-view.directive';
import { StatusSelectDialogComponent } from './components/status-select-dialog/status-select-dialog.component';
import { ResultMessageComponent } from './components/result-message/result-message.component';
import { LinkErrorDialogComponent } from './dialogs/link-error-dialog/link-error-dialog.component';
import { TreeNavigationDialogComponent } from './dialogs/tree-navigation-dialog/tree-navigation-dialog.component';
import { MatTreeModule } from '@angular/material/tree';
import { provideQueryClientOptions } from '@ngneat/query';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { LoadingBarComponent } from './components/loading-bar/loading-bar.component';
import { MatOptionModule } from '@angular/material/core';
import { OpenInNewTabDirective } from './components/open-in-new-tab.directive';

@NgModule({
  declarations: [
    StructureListViewComponent,
    SplitViewComponent,
    StructureListItemComponent,
    ConfirmDialogComponent,
    TreeNavigationDialogComponent,
    DocumentNotFoundDialogComponent,
    LoadingIndicatorComponent,
    PlanningJobSelectComponent,
    StatusLabelComponent,
    StatusSelectComponent,
    ErrorDialogComponent,
    NodeValueListViewComponent,
    DocumentImagesComponent,
    StructureBreadCrumbComponent,
    TruncatedTextComponent,
    ScrollIntoViewDirective,
    StatusSelectDialogComponent,
    ResultMessageComponent,
    LinkErrorDialogComponent,
    LoadingBarComponent,
    OpenInNewTabDirective
  ],
  imports: [
    LivedokwebRouting,
    CommonModule,
    MatSidenavModule,
    MatInputModule,
    MatIconModule,
    MatToolbarModule,
    MatMenuModule,
    MatButtonModule,
    MatListModule,
    MatBottomSheetModule,
    AngularSplitModule,
    MatRadioModule,
    MatGridListModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    ComponentsModule,
    TranslateModule,
    MatCardModule,
    MatDialogModule,
    MatTooltipModule,
    MatBadgeModule,
    MatTableModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatTabsModule,
    MatExpansionModule,
    MatButtonToggleModule,
    RoesbergModule,
    ScrollingModule,
    MatTreeModule,
    MatProgressBarModule,
  ],
  exports: [
    SplitViewComponent,
    StructureListViewComponent,
    StatusLabelComponent,
    StatusSelectComponent,
    NodeValueListViewComponent,
    LoadingIndicatorComponent,
    DocumentImagesComponent,
    TruncatedTextComponent,
    ResultMessageComponent,
    LoadingBarComponent,
    RoesbergModule,
    MatTableModule,
    MatTabsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatOptionModule,
    MatSelectModule,
    MatCardModule,
    TranslateModule,
    MatIconModule,
    PlanningJobSelectComponent,
    OpenInNewTabDirective
  ],
  providers: [
    { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: CustomTooltipDefaults },
    provideQueryClientOptions({
      defaultOptions: {
        queries: {
          staleTime: 3600,
        },
      },
    }),
    // {provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy}
  ],
})
export class SharedModule { }
